import { MockedResponse } from '@apollo/client/testing';
import { ApolloError } from '@apollo/client';
import { GetBoughtItemsFeedbackModalDocument } from '../../utils/hooks/getBoughtItemsFeedbackModal';
import { UpdateBoughtItemFeedbackDocument } from '../../utils/hooks/updateBoughtItemFeedback';
import { MultipleChoiceQuestion } from './FeedbackModal';
import { NarvarConst } from '../../utils/constants/NarvarValues';
import { GetClientConfigParamsDocument } from '../../utils/hooks/getClientConfigParams';

export const keptItemFeedbackUpdateInput = {
  feedback: {
    questionSetId: 'v1:question_set:unified_item_level_feedback',
    questions: [
      { questionId: 'multiple_choice_size', value: 'just_right' },
      { questionId: 'multiple_choice_fit_cut', value: 'just_ok' },
      { questionId: 'multiple_choice_style', value: 'just_ok' },
      { questionId: 'multiple_choice_quality', value: 'average' },
      {
        questionId: 'multiple_choice_price',
        value: 'just_right_price_variant',
      },
      { questionId: 'other_comments', value: 'OoOo my favorite' },
    ],
  },
  feedbackContext: 'wardrobe_bought_items',
  resourceId: 'RLOMX957R',
  skuId: '2809084',
};

export const multipleChoiceQuestions: MultipleChoiceQuestion[] = [
  {
    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
    label: 'Size',
    questionId: 'multiple_choice_size',
    options: [
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Too small',
        pointValue: '1.0',
        questionId: 'too_small_variant',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Just right',
        pointValue: '2.0',
        questionId: 'just_right',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Too big',
        pointValue: '3.0',
        questionId: 'too_big_variant',
        value: false,
      },
    ],
  },
  {
    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
    label: 'Fit/Cut',
    questionId: 'multiple_choice_fit_cut',
    options: [
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Hate it',
        pointValue: '1.0',
        questionId: 'hate_it',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Just ok',
        pointValue: '2.3',
        questionId: 'just_ok',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Like it',
        pointValue: '3.6',
        questionId: 'like_it',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Love it',
        pointValue: '5.0',
        questionId: 'love_it',
        value: false,
      },
    ],
  },
  {
    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
    label: 'Style',
    questionId: 'multiple_choice_style',
    options: [
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Hate it',
        pointValue: '1.0',
        questionId: 'hate_it',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Just ok',
        pointValue: '2.3',
        questionId: 'just_ok',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Like it',
        pointValue: '3.6',
        questionId: 'like_it',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Love it',
        pointValue: '5.0',
        questionId: 'love_it',
        value: false,
      },
    ],
  },
  {
    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
    label: 'Quality',
    questionId: 'multiple_choice_quality',
    options: [
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Poor',
        pointValue: '1.0',
        questionId: 'poor',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Average',
        pointValue: '2.0',
        questionId: 'average',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Great',
        pointValue: '3.0',
        questionId: 'great',
        value: false,
      },
    ],
  },
  {
    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
    label: 'Price',
    questionId: 'multiple_choice_price',
    options: [
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Too high',
        pointValue: '4.0',
        questionId: 'too_high',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'Just right',
        pointValue: '3.0',
        questionId: 'just_right_price_variant',
        value: false,
      },
      {
        __typename: 'KeptItemFeedbackMultipleChoiceQuestionOption',
        label: 'A steal',
        pointValue: '2.0',
        questionId: 'steal',
        value: false,
      },
    ],
  },
];

export const commentQuestion = {
  questionId: 'other_comments',
  value: '',
};

const getBoughtItemsFeedbackModalResult = (orderType: string) => {
  return {
    data: {
      client: {
        __typename: 'Client',
        wardrobe: {
          __typename: 'WardrobeContentModule',
          boughtModule: {
            __typename: 'WardrobeBoughtModule',
            boughtItemFeedbackModal: {
              __typename: 'WardrobeBoughtItemFeedbackModal',
              boughtItem: {
                __typename: 'KeptItem',
                eligibleForReturn: false,
                shopProduct: {
                  __typename: 'ShopProduct',
                  brand: {
                    __typename: 'Brand',
                    name: 'The North Face',
                  },
                  name: 'Novelty Cyclone Wind Hoodie',
                },
                variant: {
                  __typename: 'ShopProductVariant',
                  size: {
                    __typename: 'Size',
                    name: 'M',
                  },
                },
                orderType,
              },
              feedbackQuestions: {
                __typename: 'KeptItemFeedbackQuestionSet',
                questions: [
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Size',
                    questionId: 'multiple_choice_size',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Too small',
                        pointValue: '1.0',
                        questionId: 'too_small_variant',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just right',
                        pointValue: '2.0',
                        questionId: 'just_right',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Too big',
                        pointValue: '3.0',
                        questionId: 'too_big_variant',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Fit/Cut',
                    questionId: 'multiple_choice_fit_cut',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Hate it',
                        pointValue: '1.0',
                        questionId: 'hate_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just ok',
                        pointValue: '2.3',
                        questionId: 'just_ok',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Like it',
                        pointValue: '3.6',
                        questionId: 'like_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Love it',
                        pointValue: '5.0',
                        questionId: 'love_it',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Style',
                    questionId: 'multiple_choice_style',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Hate it',
                        pointValue: '1.0',
                        questionId: 'hate_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just ok',
                        pointValue: '2.3',
                        questionId: 'just_ok',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Like it',
                        pointValue: '3.6',
                        questionId: 'like_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Love it',
                        pointValue: '5.0',
                        questionId: 'love_it',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Quality',
                    questionId: 'multiple_choice_quality',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Poor',
                        pointValue: '1.0',
                        questionId: 'poor',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Average',
                        pointValue: '2.0',
                        questionId: 'average',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Great',
                        pointValue: '3.0',
                        questionId: 'great',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Price',
                    questionId: 'multiple_choice_price',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Too high',
                        pointValue: '4.0',
                        questionId: 'too_high',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just right',
                        pointValue: '3.0',
                        questionId: 'just_right_price_variant',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'A steal',
                        pointValue: '2.0',
                        questionId: 'steal',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackFreeformQuestion',
                    label: 'Other',
                    questionId: 'other_comments',
                    value: 'OoOo my favorite',
                    secondaryLabel: 'Other Comments?',
                  },
                ],
                questionSetId: 'v1:question_set:unified_item_level_feedback',
              },
              heading: 'Improve your style recommendations',
              subheading: 'Leave feedback to help us learn about you',
              returnHeading: 'Did this item not work out for you?',
              returnBody:
                'You have 30 days from purchase date to return or exchange unworn items.',
            },
          },
        },
      },
    },
  };
};

const getBoughtItemsFeedbackModalEligibleForReturnResult = (
  orderType: string,
) => {
  return {
    data: {
      client: {
        __typename: 'Client',
        wardrobe: {
          __typename: 'WardrobeContentModule',
          boughtModule: {
            __typename: 'WardrobeBoughtModule',
            boughtItemFeedbackModal: {
              __typename: 'WardrobeBoughtItemFeedbackModal',
              boughtItem: {
                __typename: 'KeptItem',
                eligibleForReturn: true,
                shopProduct: {
                  __typename: 'ShopProduct',
                  brand: {
                    __typename: 'Brand',
                    name: 'The North Face',
                  },
                  name: 'Novelty Cyclone Wind Hoodie',
                },
                variant: {
                  __typename: 'ShopProductVariant',
                  size: {
                    __typename: 'Size',
                    name: 'M',
                  },
                },
                orderType,
              },
              feedbackQuestions: {
                __typename: 'KeptItemFeedbackQuestionSet',
                questions: [
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Size',
                    questionId: 'multiple_choice_size',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Too small',
                        pointValue: '1.0',
                        questionId: 'too_small_variant',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just right',
                        pointValue: '2.0',
                        questionId: 'just_right',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Too big',
                        pointValue: '3.0',
                        questionId: 'too_big_variant',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Fit/Cut',
                    questionId: 'multiple_choice_fit_cut',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Hate it',
                        pointValue: '1.0',
                        questionId: 'hate_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just ok',
                        pointValue: '2.3',
                        questionId: 'just_ok',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Like it',
                        pointValue: '3.6',
                        questionId: 'like_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Love it',
                        pointValue: '5.0',
                        questionId: 'love_it',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Style',
                    questionId: 'multiple_choice_style',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Hate it',
                        pointValue: '1.0',
                        questionId: 'hate_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just ok',
                        pointValue: '2.3',
                        questionId: 'just_ok',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Like it',
                        pointValue: '3.6',
                        questionId: 'like_it',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Love it',
                        pointValue: '5.0',
                        questionId: 'love_it',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Quality',
                    questionId: 'multiple_choice_quality',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Poor',
                        pointValue: '1.0',
                        questionId: 'poor',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Average',
                        pointValue: '2.0',
                        questionId: 'average',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Great',
                        pointValue: '3.0',
                        questionId: 'great',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackMultipleChoiceQuestion',
                    label: 'Price',
                    questionId: 'multiple_choice_price',
                    options: [
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Too high',
                        pointValue: '4.0',
                        questionId: 'too_high',
                        value: false,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'Just right',
                        pointValue: '3.0',
                        questionId: 'just_right_price_variant',
                        value: true,
                      },
                      {
                        __typename:
                          'KeptItemFeedbackMultipleChoiceQuestionOption',
                        label: 'A steal',
                        pointValue: '2.0',
                        questionId: 'steal',
                        value: false,
                      },
                    ],
                  },
                  {
                    __typename: 'KeptItemFeedbackFreeformQuestion',
                    label: 'Other',
                    questionId: 'other_comments',
                    value: 'OoOo my favorite',
                    secondaryLabel: 'Other Comments?',
                  },
                ],
                questionSetId: 'v1:question_set:unified_item_level_feedback',
              },
              heading: 'Improve your style recommendations',
              subheading: 'Leave feedback to help us learn about you',
              returnHeading: 'Did this item not work out for you?',
              returnBody:
                'You have 30 days from purchase date to return or exchange unworn items.',
            },
          },
        },
      },
    },
  };
};

export const getBoughtItemsFeedbackModalEligibleForReturnMock: MockedResponse =
  {
    request: {
      query: GetBoughtItemsFeedbackModalDocument,
      variables: {
        skuId: '2809084',
        orderId: 'RLOMX957R',
      },
    },
    result: getBoughtItemsFeedbackModalEligibleForReturnResult('direct_buy'),
  };

export const getBoughtItemsFeedbackModalMock: MockedResponse = {
  request: {
    query: GetBoughtItemsFeedbackModalDocument,
    variables: {
      skuId: '2809084',
      orderId: 'RLOMX957R',
    },
  },
  result: getBoughtItemsFeedbackModalResult('direct_buy'),
};

export const getBoughtItemsFeedbackModalMockForFixItem: MockedResponse = {
  request: {
    query: GetBoughtItemsFeedbackModalDocument,
    variables: {
      skuId: '2809084',
      orderId: 'RLOMX957R',
    },
  },
  result: getBoughtItemsFeedbackModalResult('fix_shipment'),
};

export const getBoughtItemsFeedbackModalErrorMock: MockedResponse = {
  request: {
    query: GetBoughtItemsFeedbackModalDocument,
  },
  error: new ApolloError({ errorMessage: 'Error!' }),
};

export const UpdateBoughtItemFeedbackMutationMock = (): MockedResponse => ({
  request: {
    query: UpdateBoughtItemFeedbackDocument,
    variables: {
      input: keptItemFeedbackUpdateInput,
    },
  },
  result: {
    data: {
      keptItemClientFeedbackUpdate: {
        result: {
          skuId: '2809084',
          __typename: 'KeptItemClientFeedbackUpdateResult',
        },
        __typename: 'KeptItemClientFeedbackUpdatePayload',
      },
    },
  },
});

export const getClientConfigsEnabledResponseData = {
  client: {
    configParams: [
      {
        name: NarvarConst.returns_redesign_name,
        value: NarvarConst.returns_redesign_enabled,
      },
    ],
    capabilities: { canShop: false, canScheduleFix: false },
    businessLine: 'WOMENS',
    id: '12345',
  },
};

export const getClientConfigsDisabledResponseData = {
  client: {
    configParams: [
      {
        name: NarvarConst.returns_redesign_name,
        value: NarvarConst.returns_redesign_disabled,
      },
    ],
    capabilities: { canShop: false, canScheduleFix: false },
    businessLine: 'WOMENS',
    id: '12345',
  },
};

export const getClientConfigsMock = (): MockedResponse => ({
  request: {
    query: GetClientConfigParamsDocument,
    variables: {
      input: {
        offlineLookupOnly: false,
        params: [
          {
            name: NarvarConst.returns_redesign_name,
            expectedValues: [
              NarvarConst.returns_redesign_enabled,
              NarvarConst.returns_redesign_disabled,
            ],
            fallbackValue: NarvarConst.returns_redesign_disabled,
          },
        ],
      },
    },
  },
  result: { data: getClientConfigsEnabledResponseData },
});

export const getClientConfigsNotNarvarMock = (): MockedResponse => ({
  request: {
    query: GetClientConfigParamsDocument,
    variables: {
      input: {
        offlineLookupOnly: false,
        params: [
          {
            name: NarvarConst.returns_redesign_name,
            expectedValues: [
              NarvarConst.returns_redesign_enabled,
              NarvarConst.returns_redesign_disabled,
            ],
            fallbackValue: NarvarConst.returns_redesign_disabled,
          },
        ],
      },
    },
  },
  result: { data: getClientConfigsDisabledResponseData },
});
